import { render } from "./lrbYTable3.vue?vue&type=template&id=90ba5590&scoped=true"
import script from "./lrbYTable3.vue?vue&type=script&lang=js"
export * from "./lrbYTable3.vue?vue&type=script&lang=js"

import "./lrbYTable3.vue?vue&type=style&index=0&id=90ba5590&lang=scss&scoped=true"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90ba5590"]])

export default __exports__